export default __webpack_public_path__ + "img/867077b782cc68d31a1a7be7bf667022.png";